import React from "react";

import { Table, Button
  } from "reactstrap";

var sdf = require('date-format');

export const  StandardList = ( { title, rows, cols , actions, showQty = true} ) => { 
     return (
       
        <>
          <p className="dash-obj-title">
          {showQty && rows && rows.length} {title}
                    </p>
          <Table responsive>
              <thead>
                  <tr>
                    {cols.map( ( col ) => {
                      return (
                        <th className={col.align?"text-"+col.align:"text-center"}>{col.title}</th>
                        )
                      })
                    }
                  </tr>
              </thead>
              <tbody>

                {rows && rows.map( (row) => {
                  return (
                          <tr>
                             {cols.map( ( col ) => {
                               return (
                                 <>
                                {col.type === "IMG" && <td className={col.align?"text-"+col.align:"text-center"}>
                                {row[col.id]?
                                  <img src={row[col.id]} alt={col.id} width={col.size?col.size:"200"} />
                                   :
                                  "Sin Imagen" 
                                }

                                </td>}
                                {col.type === "STRING"&& <td className={col.align?"text-"+col.align:"text-center"}>{row[col.id]}</td>}
                                {col.type === "DATETIME"&&
                                   <td className={col.align?"text-"+col.align:"text-center"}>
                                     {
                                          sdf.asString('dd/MM/yyyy hh:mm:ss', new Date(row[col.id]))
                                    }
                                    </td> 
                                }
                                {col.type === "DATE"&&
                                   <td className={col.align?"text-"+col.align:"text-center"}>
                                     {
                                          sdf.asString('dd/MM/yyyy', new Date(row[col.id]))
                                    }
                                    </td> 
                                }
                               
                               {col.type === "DECIMAL"&& <td className={col.align?"text-"+col.align:"text-center"}>{row[col.id]}</td>}
                               {col.type === "YESNO"&& <td className={col.align?"text-"+col.align:"text-center"}>{row[col.id]}</td>}
                               
                               {col.type === "COLOR"&& 
                                  <td className={col.align?"text-"+col.align:"text-center"} style={{color: row[col.id]}}>
                                    <b>{row[col.id]}</b>
                                  </td>}
                                </>
                               ) 
                                })
                              }
                             
                            <td className="text-right">
                
                              { actions.map( (action) => {
                                return ( 
                                  <Button  size="sm" 
                                    color={action.type}  
                                    onClick={() => action.act( row )}>
                                    {action.label}
                                  </Button> 
                                  ) 
                                }
                              )} 
                                  
                            </td>
                          </tr>
                      )
                }) }
 
              </tbody>
          </Table> 
        </>
    );
  }


